
import { Crisp } from "crisp-sdk-web";

export function showChat() {
  Crisp.chat.open();
}
